"use strict";

exports.__esModule = true;
exports.createTheme = createTheme;

var _themes = require("@manifest-ui/themes");

var _mergeTheme = require("./mergeTheme");

function createTheme(theme) {
  if (process.env.NODE_ENV !== 'production' && theme?.colors?.secondary) {
    console.error('Manifest UI: overriding the secondary color is currently not supported.');
  }

  return (0, _mergeTheme.mergeTheme)(_themes.defaultTheme, theme);
}